import * as React from 'react';
import { CircularProgress } from '@material-ui/core';

import * as S from './Spinner.styled';

const CommonSpinner = () => {
  return (
    <S.SpinnerSpacing>
      <CircularProgress size={19} thickness={4} />
    </S.SpinnerSpacing>
  );
};

export default CommonSpinner;
